import styled from '@emotion/styled';
import { KizenTypography } from '__app/typography';

export const StyledNotice = styled(KizenTypography)`
  padding: 10px;
  background-color: var(--color-feedback-info-bg);
  margin-bottom: 15px;
`;

export const StyledReferenceFields = styled.div`
  min-height: calc(100vh - 540px);
`;
